import { NotAuthorizedPage, Protected } from "@dgs/core";
import { FC } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { AppProviders } from "./app_providers";
import { PersonalManagerAuthPages } from "./auth";
import { Content } from "./content";

export const App: FC = () => {
	return (
		<AppProviders>
			<Routes>
				<Route path="/auth/*" index element={<PersonalManagerAuthPages />} />
				<Route
					path="*"
					index
					element={
						<Protected fallback={<Navigate to="/auth/login" replace />}>
							<Content />
						</Protected>
					}
				/>
				<Route path="not-authorized" element={<NotAuthorizedPage title="Personal Manager" redirect={-1} />} />
			</Routes>
		</AppProviders>
	);
};
